export {
    Type,
    fromJSON,
    instanceOf,
    fromHexString,
    fromBuffer,
    toHexString,
    toBuffer,
    equals,
    JSON_DISCRIMINATOR,
    Serializable,
    toTypedJSON,
    toUnwrappedJSON,
    fromTypedJSON,
} from '../../types/BlockHash.js';
